import React from "react";

export const DEPLOY_ENVS = {
  LOCAL: "DE_L",
  DEVELOP: "DE_D",
  STAGING: "DE_S",
  PRODUCTION: "DE_P"
};

export const DEPLOY_ENV =
  typeof document === "undefined" ||
    document.location.origin.indexOf("http://localhost") === 0
    ? DEPLOY_ENVS.LOCAL
    : document.location.origin.indexOf("https://staging") === 0
      ? DEPLOY_ENVS.STAGING
      : document.location.origin.indexOf("https://develop") === 0
        ? DEPLOY_ENVS.DEVELOP
        : DEPLOY_ENVS.PRODUCTION;

export const STAGING_AUTH_COOKIE = "ffx-auth=covfefe";

// This is temporary, for the purposes of testing to do with the requirements of our staging bucket,
// should traffic to it pass through the staging CDN
if ((DEPLOY_ENV === DEPLOY_ENVS.STAGING || DEPLOY_ENV === DEPLOY_ENVS.DEVELOP) && typeof document !== "undefined") {
  document.cookie = STAGING_AUTH_COOKIE;
}

const AWS_BUCKET_URL_ROOT_FOR_LOCALHOST = process.env.REACT_APP_LOCAL_DEV_S3_URL
  ? process.env.REACT_APP_LOCAL_DEV_S3_URL
  : "https://staging-publishing-prez-hub-bucket.s3-ap-southeast-2.amazonaws.com/";

const AWS_BUCKET_PRODUCTION_URL_ROOT =
  "https://www.smh.com.au/interactive/hub/";

const AWS_BUCKET_STAGING_URL_ROOT =
  "https://s3-ap-southeast-2.amazonaws.com/interactives-hub-development-v1.apse2.ffx.io/";

const AWS_BUCKET_DEVELOP_URL_ROOT = "https://dev-prez-hub.s3.amazonaws.com/";

const AWS_BUCKET_LOCALHOST_URL_ROOT = AWS_BUCKET_URL_ROOT_FOR_LOCALHOST;

export const AWS_BUCKET_URL_ROOT =
  DEPLOY_ENV === DEPLOY_ENVS.LOCAL
    ? AWS_BUCKET_LOCALHOST_URL_ROOT
    : DEPLOY_ENV === DEPLOY_ENVS.STAGING
      ? AWS_BUCKET_STAGING_URL_ROOT
      : DEPLOY_ENV === DEPLOY_ENVS.DEVELOP
        ? AWS_BUCKET_DEVELOP_URL_ROOT
        : AWS_BUCKET_PRODUCTION_URL_ROOT;

const AWS_BUCKET_PRODUCTION_RAW_URL_ROOT =
  "https://www.smh.com.au/interactive/hub/";
//"https://s3-ap-southeast-2.amazonaws.com/interactives-hub-production-v1.apse2.ffx.io/";
const AWS_BUCKET_STAGING_RAW_URL_ROOT =
  "https://s3-ap-southeast-2.amazonaws.com/interactives-hub-development-v1.apse2.ffx.io/";

const AWS_BUCKET_DEVELOP_RAW_URL_ROOT = "https://dev-prez-hub.s3.amazonaws.com/";

const AWS_BUCKET_LOCALHOST_RAW_URL_ROOT = AWS_BUCKET_URL_ROOT_FOR_LOCALHOST;

export const AWS_BUCKET_RAW_URL_ROOT =
  DEPLOY_ENV === DEPLOY_ENVS.LOCAL
    ? AWS_BUCKET_LOCALHOST_RAW_URL_ROOT
    : DEPLOY_ENV === DEPLOY_ENVS.STAGING
      ? AWS_BUCKET_STAGING_RAW_URL_ROOT
    : DEPLOY_ENV === DEPLOY_ENVS.DEVELOP
      ? AWS_BUCKET_DEVELOP_RAW_URL_ROOT
      : AWS_BUCKET_PRODUCTION_RAW_URL_ROOT;

export const GENERIC_RETRY_ADVICE =
  "Please take a moment, try again and if things still don't work, report this error using the button below or by writing to us in the '#prez-hub-feedback' channel.";

export const EXTERNAL_CONNECTION_ERRORS = {
  CREATE_STUB: `There was an error when attempting to create a work-in-progress save file for this configuration. This may affect your ability to save your configuration. If this problem persists, please report this to '#prez-hub-feedback'.`,
  DELETE_RECORD: `There was an error when attempting to delete the selected configuration. ${GENERIC_RETRY_ADVICE}`,
  GET_RECORD: `The configuration selected failed to load. ${GENERIC_RETRY_ADVICE}`,
  GET_RECORDS: `There was an error when attempting to load this application's configurations. ${GENERIC_RETRY_ADVICE}`,
  SAVE_RECORD: `There was an error when attempting to save the selected configuration. ${GENERIC_RETRY_ADVICE}`,
  LOAD_IMAGE: `There was an error when attempting to load the image from that url. Check the url. ${GENERIC_RETRY_ADVICE}`
};

export const APP_RECORDS_SOURCE_OPTIONS = [
  { value: "your-files", label: "Your files" },
  { value: "all-users-files", label: "All users' files" }
];

export const DANGEROUS_RECORD_SHARING_WARNING = (
  <span>
    <strong>
      If somebody else is editing the same configuration as you, you risk
      overwriting each other's changes.
    </strong>{" "}
    There are no 'taking over' features to safeguard against this, so only a
    select group of users - <strong>admins</strong>, <strong>editors</strong>{" "}
    and <strong>specialists</strong> - can so far edit other users' files.{" "}
    <strong>It is your responsibility to make sure issues don't arise.</strong>
  </span>
);

export const GROUPS_WITH_EDITING_PRIVILEGES = [
  "producer_user",
  "editor_user",
  "admin_user",
  "specialist_user"
];

export default {
  APP_RECORDS_SOURCE_OPTIONS,
  AWS_BUCKET_URL_ROOT,
  AWS_BUCKET_RAW_URL_ROOT,
  DANGEROUS_RECORD_SHARING_WARNING,
  DEPLOY_ENV,
  EXTERNAL_CONNECTION_ERRORS,
  GENERIC_RETRY_ADVICE,
  GROUPS_WITH_EDITING_PRIVILEGES
};
